module.exports = __webpack_public_path__ + "img/20190817131728082.0d032b74.png";